export class AnimationState {
    constructor() {
    }
}
AnimationState.stopped = 0;
AnimationState.paused = 1;
AnimationState.playing = 2;
